/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const EntityQuantityReportCreatePage = lazyLoad(
  () => import('./index'),
  module => module.EntityQuantityReportCreatePage
);
